import { render, staticRenderFns } from "./BaseFormInput.vue?vue&type=template&id=2b69efc6&"
import script from "./BaseFormInput.vue?vue&type=script&lang=js&"
export * from "./BaseFormInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports